import { faTrashCanArrowUp } from '@fortawesome/free-solid-svg-icons';
import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';

type Props = {
  menuSize: number;
  onClick(): void;
  text: string;
};

export const RemoveMultiSelectedLinksButton: React.FC<Props> = ({ menuSize, onClick, text }: Props) => {
  return (
    <g>
      <MainMenuBox menuSize={menuSize} isSelected={false} onClick={onClick} text={text} />
      <MainMenuIcon icon={faTrashCanArrowUp} menuSize={menuSize} />
    </g>
  );
};
